import type { SearchResponse } from '@algolia/client-search';
import type { FC, ProviderProps } from 'react';

import { createContext, useContext } from 'react';

import type { TileProps } from '~/components/shared/recommendations/tile/Tile';
import type { AlgoliaProduct } from '~/components/shared/recommendations/tile/types';
import type { ProductHit } from '~/types/algolia';

export interface TileContextProps extends TileProps {
  product: AlgoliaProduct;
  variants: SearchResponse<ProductHit>['hits'];
  baseImageUrl?: string;
  aspectRatio?: number;
}

const TileContext = createContext<TileContextProps | undefined>(undefined);

export const useTileContext = () => {
  const context = useContext(TileContext);

  if (context === undefined) {
    throw new Error('`useTileContext` is used outside the `<TileProvider />');
  }

  return context;
};

export const TileProvider: FC<ProviderProps<TileContextProps>> = ({ children, value }) => (
  <TileContext value={value}>{children}</TileContext>
);
